import {Alert, Button, Container, Space} from "@mantine/core";
import {IconAlertCircle} from "@tabler/icons";
import {Link} from "react-router-dom";

interface No2FABannerProps {
    isAdmin: boolean;
}

export function No2FABanner({isAdmin}: No2FABannerProps) {
    return (
        <><Container>
            <Alert icon={<IconAlertCircle size="1rem"/>} title="Security Vulnerability!" color="red" variant="light">
                {isAdmin ?
                    "To ensure the security of your account, you must enable 2FA. All administration features along with some other website features are disabled until you enable 2FA." :
                    "To ensure the security of your account, you must enable 2FA. This is required to use some features, which are disabled until you enable 2FA."}
                <br/><br/><Link style={{textDecoration: 'none'}} to='/2fa/enable'><Button variant="subtle" color="red"
                                                                                      size="lg" uppercase>
                Enable 2FA
            </Button></Link>
            </Alert>
        </Container><Space h="lg"/></>
    );
}